<template>
  <div>
    <div class="title">
        <div>
            <van-icon v-if="form.Status === '已取消'" name="clear" color="#999999" size="20px"/>
            <van-icon v-else name="checked" color="#FEB013" size="20px"/>
            <a style="font-size:16px;font-weight:bold;padding-left:6px;">{{form.Status}}</a>
        </div>
        <div>{{form.DateTime}} </div>
    </div>
    <div class="card-box">
        <div class="card-title">
            <a class="card-title-text">拼车信息</a>
            <a class="route-btn">路线{{form.Route}}</a>
        </div>
        <div class="routebox">
            <div style="width: 30%;">
                <div class="start-icon">起</div>
                <div>公司</div>
            </div>
            <div style="width: 30%;text-align: center;">
                <div class="center-text">{{form.DepartTime}}发车</div>
            </div>
            <div style="text-align: -webkit-right;width: 30%;">
                <div class="end-icon">终</div>
                <div>{{form.Destination}}</div>
            </div>
        </div>
        <div style="padding:8px 0 4px 0;font-size:14px;">途径  {{form.Way}}</div>
        <div style="padding:4px 0">
            <van-icon name="medal" color="#C9C9C9"/>
            <a style="font-size: 12px;">{{form.Remark?form.Remark:'司机没有填写备注哦~'}}</a>
        </div>
    </div>
    <div class="card-box">
        <div class="card-title">
            <a class="card-title-text">其他信息</a>
        </div>
        <div v-if="role === 'passenger' && form.DateTime != $moment(new Date()).format('YYYY-MM-DD')" style="line-height: 1.5;font-size: 15px;margin-top: 8px;">
            <div class="cell">
                <a>司机姓名</a><a>{{form.Name}}</a>
            </div>
            <div class="cell">
                <a>车辆信息</a><a>{{form.Car}}|{{form.CarSeat}}座</a>
            </div>
            <div class="cell">
                <a>车牌号吗</a><a>{{form.CarNum}}</a>
            </div>
        </div>
        <div style="display: flex;align-items: center;padding:8px 0;">
            <van-image width="20" height="20" :src="require('../../assets/img2.svg')"/>
            <div class="carperson">{{form.passengers && form.passengers.length>0?'已拼'+form.passengers.length+'人':'无乘客信息' }}</div>
        </div>
        <div class="person-card" v-for="(item, key) in form.passengers" :key="key">
            <div style="display: flex;justify-content: space-between;">
                <div>
                    <a style="padding-right:8px;">{{item.Name}}</a>
                    <template v-if="role === 'driver'">
                        <van-icon name="phone" size="14" color="#FEB013"/>
                        <a class="passenger-tel" :href="'tel://' + item.Phone">{{item.Phone}}</a>                        
                    </template>
                </div>
                <div>
                    <van-icon name="clock" color="#C9C9C9"/>
                    <a style="color:#999999;padding-left:4px;">{{$moment(item.CreateTime).format('HH:mm')}}拼车</a>
                </div>
            </div>
        </div>
    </div>
    <div v-if="role === 'passenger'" class="card-box" style="padding:1px;">
        <van-cell center title="开启订阅该司机">
            <template #right-icon>
                <van-switch :value="checked" size="24" active-color="#FEB013" inactive-color="#C9C9C9" @input="onSubscribe"/>
            </template>
        </van-cell>
    </div>
    <template v-if="form.DateTime === $moment(new Date()).format('YYYY-MM-DD')">
        <div style="height:180px;"></div>
        <div class="bottom-box">
            <div v-if="role === 'passenger'" class="bottom-driver-card">
                <div style="display: flex;">
                <van-image width="40" height="40" round :src="form.Avatar"/>
                <div style="padding-left:8px;">
                    <div style="font-weight: bold;">{{form.Name}}  {{form.CarNum}}</div>
                    <div style="font-size:12px;">({{form.Car}} | {{form.CarSeat}}座)</div>
                </div>
                </div>
                <a style="text-align: center;color: black;" :href="'tel://' + form.Phone">
                    <van-icon name="phone" size="32" color="#FEB013"/>
                    <div style="font-size:12px;">联系司机</div>
                </a>
            </div>
            <div class="bottom-btn">
                <van-button round block @click="showBox = true" :disabled="cancleBtn">取消订单</van-button>
                <van-button
                    v-if="role === 'driver'"
                    :disabled="disableBtn"
                    round block color="#333333"
                    style="margin-left: 20px;"
                    @click="showConfirm = true">确认发车</van-button>
            </div>
        </div>        
    </template>

    <van-popup v-model="showSubscribe" closeable style="width: 80%;">
        <div style="text-align: center;line-height:1.5;padding: 40px 0px 20px 0;">
            <div style="font-size: 18px;font-weight: 600;">{{test?'已开启订阅':'取消订阅司机'}}</div>
            <div style="color: #999999;">{{test?'司机发布路线后会推送消息给您':('确定不再订阅司机['+form.Name+']行程')}}</div>
        </div>
        <div class="cancle-btn" v-show="!test" @click="cancleSub">取消订阅</div>
    </van-popup>

    <van-popup v-model="showBox" round position="bottom" closeable safe-area-inset-bottom style="text-align:center;padding-top:50px;">
        <div style="font-size:20px;font-weight:600;">确认取消拼车?</div>
        <div style="font-size:14px;color: #999999;">取消订单后将要重新确认拼车服务</div>
        <van-button :disabled="cancleBtn" round block color="#333333" @click="onSubmit('cancle')" style="margin:35px auto;width:90%;">确认</van-button>     
    </van-popup>
    <van-popup v-model="showConfirm" round position="bottom" closeable safe-area-inset-bottom style="text-align:center;padding-top:50px;">
        <div style="font-size:20px;font-weight:600;">确认发车?</div>
        <div style="font-size:14px;color: #999999;">确认后将无法取消</div>
        <van-button :disabled="disableBtn" round block color="#333333" @click="onSubmit('confirm')" style="margin:35px auto;width:90%;">确认</van-button>     
    </van-popup>
  </div>
</template>

<script>
export default {
    data() {
        return {
            checked: false,
            role: '',
            form: {},
            disableBtn: false,
            showBox: false,
            showConfirm: false,
            cancleBtn: false,
            showSubscribe: false,
            test: true,
            // showSuccess: false,
            // showFalse: false,
            subscribeList: []
        }
    },
    async mounted() {
        // const test = {"errno":0,"data":{"errcode":0,"errmsg":"ok","userid":"2017551","name":"吴昌悦","department":[2267],"position":"软件开发工程师","mobile":"15812615614","gender":"1","email":"wuchangyue@jianlianmed.com","avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/0","status":1,"isleader":0,"extattr":{"attrs":[{"name":"英文名","value":"","type":0,"text":{"value":""}},{"name":"工号","value":"2017551","type":0,"text":{"value":"2017551"}},{"name":"身份证","value":"","type":0,"text":{"value":""}}]},"english_name":"","telephone":"020-88985632","enable":1,"hide_mobile":0,"order":[0],"external_profile":{"external_attr":[],"external_corp_name":""},"main_department":2267,"qr_code":"https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc5b6c10860443246c","alias":"","is_leader_in_dept":[0],"address":"","thumb_avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/100","direct_leader":[],"openid":"ozAQBt9Jauj5fMYuM9Q0bNmhaAo8","access_token":"hER4OJaZReJSc_9Mi6NCJTXyliK2QkEDuj0ruK4CsiFGKySTq81qK6AsR7GqX6bROcq28TctrjQqtXheO0mKenvkX6pu6kkuP9cSO51qDnBHwnOThgl4thnSeAFw_PlA0aUdAX3tE5yPHs3IIgOwB4bEc6yFKchMe7tjjaACla90dBlIe8j8JuSB-SOLpoWVXMI36ulQW7uRs6VXRfH57w"}}
        // this.WXInfo = test.data
        this.WXInfo = JSON.parse(localStorage.getItem('userinfo')).data
        this.role = this.$route.query.role
        await this.getTravelData()
        this.getUserInfoData(this.form.UserId)
        if (this.$route.query.userid && this.$route.query.userid !== this.WXInfo.userid) {
            this.$toast('抱歉您不是本订单司机无法操作')
            this.$router.push('/index')
        }
    },
    methods: {
        async cancleSub () {
            const arr = JSON.parse(JSON.stringify(this.subscribeList))
            const index = arr.findIndex(item => item === this.WXInfo.userid)
            this.subscribeList.splice(index, 1)
            const obj = {
                SubscribeUser: JSON.stringify(this.subscribeList)
            }
            const result = await this.postUserData(obj)
            if (result.success) {
                this.showSubscribe = false
                this.checked = false
            }
        },
        async onSubscribe (checked) {
            if (checked) {
                this.subscribeList = this.subscribeList.concat([this.WXInfo.userid])
                const obj = {
                    SubscribeUser: JSON.stringify(this.subscribeList)
                }
                const result = await this.postUserData(obj)
                if (result.success) {
                    this.test = true
                    this.showSubscribe = true
                    this.checked = true
                }
            } else {
                this.showSubscribe = true
                this.test = false
            }
        },
        async onSubmit (type) {
            let data = {}
            let result = {}
            if (this.role === 'driver') {
                if (type === 'confirm') {
                    data = { Status: '已发车' }
                } else if (type === 'cancle') {
                    data = { Status: '已取消' }
                } else {
                    console.log('nothing')
                }
                result = await this.postUpdateTravel(data)
            } else {
                const id = this.form.passengers.find(val => val.UserId === this.WXInfo.userid)._id
                result = await this.deletePassenger(id)
            }
            this.$toast(result.message)
            if (result.message === '已确认发车') {
                this.disableBtn = true
                this.cancleBtn = true
                this.showConfirm = false
                this.form.Status = '已发车'
                // 发送信息告诉乘客
                let userlist = ''
                this.form.passengers.forEach(ele => {
                    userlist = userlist + ele.UserId + '|'
                })
                let message = this.form.DateTime +' '+ this.$moment(new Date()).format('HH:mm') + ' 司机['+ this.WXInfo.name +']现已发车，如若没上车请及时跟司机沟通。'
                this.postSendMessage(userlist.slice(0, userlist.length - 1), message)
            } else if (result.message === '没有乘客，无法发车' || result.message === '当前车辆已发车，不允许取消' || result.message === '乘客已拼车，无法取消') {
                this.showBox = false
                this.showConfirm = false
                this.getTravelData()
            } else {
                this.$router.push('/index')
                if (this.role === 'passenger') {
                    let message = this.form.DateTime +' '+ this.$moment(new Date()).format('HH:mm') + ' 乘客['+ this.WXInfo.name +']取消乘坐您发布的行程路线'
                    this.postSendMessage(this.form.UserId, message)
                }
            }
        },
        postUpdateTravel (data) {
            return this.$request({
                url: this.$api.postUpdateTravel,
                method: 'POST',
                params: {
                    _id: this.form._id,
                    DateTime: this.$moment(new Date()).format('YYYY-MM-DD')
                },
                data
            })
        },
        deletePassenger (id) {
            return this.$request({
                url: this.$api.deletePassenger,
                method: 'DELETE',
                params: {
                    Id: id,
                    ParentsId: this.form._id
                }
            })
        },
        async getTravelData() {
            const result = await this.$request({
                url: this.$api.getAllRouteList,
                method: 'GET',
                params: {
                    _id: this.$route.query.id
                }
            })
            if (result.data.length > 0) {
                this.form = result.data[0]
                if (this.form.Status === '已发布') {
                    this.disableBtn = false
                    this.cancleBtn = false
                } else if (this.form.Status === '已满座') {
                    this.disableBtn = false
                    this.cancleBtn = false
                // } else if (this.form.Status === '已发车') {
                //     this.disableBtn = true
                //     this.cancleBtn = true
                } else if (this.form.Status === '已拼车') {
                    this.disableBtn = true
                    this.cancleBtn = false
                } else {
                    this.disableBtn = true
                    this.cancleBtn = true
                }
                if (this.role === 'passenger') {
                    this.form.Status = this.form.passengers.find(val => val.UserId === this.WXInfo.userid).Status
                }
            } else {
                this.$toast(result.message)
            }
        },
        async postSendMessage(userid, message) {
            const result = await this.$request({
                url: this.$api.postSendMessageWX,
                method: 'POST',
                data: {
                    'touser': userid,
                    'msgtype': 'text',
                    'agentid': this.$agentid,
                    'text': { 'content': message }
                }
            })
            if (!result.success) {
                this.$toast(result.message)
            }
        },
        // 查询用户数据
        async getUserInfoData(userId) {
            const result = await this.$request({
                url: this.$api.getUserInfo,
                method: 'GET',
                params: {
                    UserId: userId
                }
            })
            if (result.data.length > 0 && result.data[0].SubscribeUser) {
                 this.subscribeList = result.data[0].SubscribeUser
                this.checked = this.subscribeList.includes(this.WXInfo.userid)
            }
        },
        postUserData(data) {
            return this.$request({
                url: this.$api.postUserCar,
                method: 'POST',
                params: {
                    UserId: this.form.UserId
                },
                data: Object.assign({ UserId: this.form.UserId }, data)
            })
        }
    }
}
</script>

<style scoped>
.title{
    padding:15px 16px;
    background-color:#FFFFFF;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.card-box {
    background: #FFFFFF;
    border-radius:4px;
    margin:8px 12px;
    padding: 8px 12px;
}
.card-title {
    border-bottom:1px solid #D2D2D2;
    padding-bottom:8px;
}
.card-title-text {
    font-size:15px;
    padding-right:8px;
}
.route-btn {
    border:1px solid #999999;
    color:#999999;
    border-radius:4px;
    padding: 3px;
    font-size:12px;
}
.routebox {
    font-size: 15px;
    font-weight: 600;
    padding: 8px 0;
    border-bottom:1px dashed #D2D2D2;
    display: flex;
    justify-content: space-between;
}
.start-icon {
    height: 22px;
    width: 22px;
    background-color: #39A0F4;
    color: #ffffff;
    border-radius: 50%;
    padding: 4px;
    text-align: center;
}
.center-text {
    border-bottom: 1px dashed #999999;
    margin-top: 25%;
    font-size: 14px;
    font-weight: initial;
}
.end-icon {
    height: 22px;
    width: 22px;
    background-color: #4DBE86;
    color: #ffffff;
    border-radius: 50%;
    padding: 4px;
    text-align: center;
}
.carperson {
    font-size: 12px;
    color: #F22222;
    padding-left: 4px;
}
.person-card {
    background-color: #F9F9F9;
    padding: 4px 12px;
    border-radius: 4px;
}
.bottom-box {
    background-color: #ffffff;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    border-radius: 8px 8px 0px 0px;
}
.bottom-btn {
    padding: 18px 12px;
    justify-content: space-between;
    display: flex;
    margin-bottom:34px;
}
.passenger-tel {
    padding-left:4px;
    text-decoration: underline;
    color: black;
    font-size: 14px;
}
.bottom-driver-card {
    padding:8px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.cell {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.cancle-btn {
    border-top: 1px solid #D2D2D2;
    text-align: center;
    padding: 12px 0;
    color: #FEB013;
}
</style>
